module.exports = __webpack_public_path__ + "img/厨房电器4.62b47643.jpg";